export default function (Alpine) {

    const _openModals = [];
    let _scrollbarWidth = 0;

    const _getScrollbarWidth = () => {
        if (_scrollbarWidth) return _scrollbarWidth;
        const div = document.createElement('div');
        Object.assign(div.style, { overflow: 'scroll', position: 'fixed', top: '-9999px' });
        document.body.appendChild(div);
        _scrollbarWidth = div.offsetWidth - div.clientWidth;
        div.remove();
        return _scrollbarWidth;
    };

    const _lockScroll = () => {
        const sw = _getScrollbarWidth();
        document.body.style.overflow     = 'hidden';
        if (sw) document.body.style.paddingRight = `${sw}px`;
    };

    const _unlockScroll = () => {
        document.body.style.overflow     = '';
        document.body.style.paddingRight = '';
    };

    // Global trigger delegasyonu
    document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[modal-trigger]');
        if (!trigger) return;
        e.stopPropagation();
        if (trigger.tagName === 'A') e.preventDefault();
        const sel     = trigger.getAttribute('modal-trigger');
        const modalEl = document.querySelector(sel);
        if (!modalEl) { console.warn(`[modal] bulunamadı: ${sel}`); return; }
        modalEl._x_dataStack?.[0]?.toggle(trigger);
    });

    // Escape — en üstteki modal
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && _openModals.length) {
            _openModals[_openModals.length - 1].close();
        }
    });

    // URL hash — sayfa yüklenince ve hash değişince
    const _checkHash = () => {
        return;
        const hash = location.hash.slice(1);
        if (!hash) return;
        const modalEl = document.getElementById(hash);
        if (!modalEl) return;
        const instance = modalEl._x_dataStack?.[0];
        if (instance && !instance.open) instance._open();
    };

    document.addEventListener('DOMContentLoaded', _checkHash);
    window.addEventListener('hashchange', _checkHash);


    Alpine.data('modal', () => ({

        open:           false,
        _backdropEl:    null,
        _scrollLock:    true,
        _cleanup:       [],
        _focusTrapFn:   null,
        _confirmResolve:null,

        init() {
            const root = this.$root;
            const self = this;

            self._scrollLock = root.getAttribute('scroll-lock') !== 'false';
            self._backdropEl = root.querySelector('[modal-backdrop]') ?? null;

            // Backdrop tıklaması
            if (self._backdropEl) {
                self._backdropEl.addEventListener('click', (e) => {
                    if (e.target !== self._backdropEl) return;
                    if (root.getAttribute('backdrop-dismiss') !== 'false') self.close();
                });
            }

            // modal-dismiss
            root.querySelectorAll('[modal-dismiss]').forEach(btn => {
                btn.addEventListener('click', (e) => { e.stopPropagation(); self.close(); });
            });

            // modal-confirm
            root.querySelectorAll('[modal-confirm]').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    const val = btn.getAttribute('modal-confirm') || true;
                    self._resolveConfirm(val);
                    self.close();
                });
            });

            // modal-cancel
            root.querySelectorAll('[modal-cancel]').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    self._resolveConfirm(false);
                    self.close();
                });
            });

            // Body'e taşı
            document.body.appendChild(root);
            Object.assign(root.style, { position: 'fixed', zIndex: '9999', inset: '0' });
            root.setAttribute('role', 'dialog');
            root.setAttribute('aria-modal', 'true');

            self._watch();

            if (root.hasAttribute('open')) self.$nextTick(() => self._open());
        },

        destroy() {
            this._cleanup.forEach(({ el, type, fn }) => el.removeEventListener(type, fn));
            this._cleanup = [];
            if (this._focusTrapFn) document.removeEventListener('keydown', this._focusTrapFn);
            const idx = _openModals.indexOf(this);
            if (idx > -1) _openModals.splice(idx, 1);
            if (!_openModals.some(m => m._scrollLock)) _unlockScroll();
        },


        toggle(trigger) { this.open ? this.close(trigger) : this._open(trigger); },
        show()   { if (!this.open) this._open(); },
        hide()   { this.close(); },

        // Promise döndürür — confirm/cancel beklenir
        confirm() {
            const self = this;
            return new Promise((resolve) => {
                self._confirmResolve = resolve;
                if (!self.open) self._open();
            });
        },

        _resolveConfirm(val) {
            if (this._confirmResolve) {
                this._confirmResolve(val);
                this._confirmResolve = null;
            }
        },


        _open(trigger) {
            const self = this;

            // opening eventi — bu sırada başka modal açılabilir, zincir bozulmaz
            // çünkü _open her instance'ı kendi state'ine göre yönetir
            self.$root.dispatchEvent(new CustomEvent('modal:opening', {
                detail: { modal: self, trigger },
                bubbles: true,
            }));

            // opening event handler'ı içinde açılan başka modaller kendi
            // _open() döngülerini tamamlar, sonra bu modal kendi state'ini kurar
            _openModals.push(self);
            self.open = true;

            if (self._scrollLock) _lockScroll();

            // Nested z-index
            const z = 9998 + (_openModals.length * 2);
            self.$root.style.zIndex = `${z}`;

            // URL hash güncelle
            if (self.$root.id) history.replaceState(null, '', `#${self.$root.id}`);

            self.$nextTick(() => {
                const dur = self._getDuration(self.$root);
                self.$root.setAttribute('opening', '');
                self._backdropEl?.setAttribute('opening', '');

                requestAnimationFrame(() => {
                    if (dur > 0) {
                        setTimeout(() => {
                            self.$root.removeAttribute('opening');
                            self._backdropEl?.removeAttribute('opening');
                        }, dur);
                    } else {
                        self.$root.removeAttribute('opening');
                        self._backdropEl?.removeAttribute('opening');
                    }
                });

                self._trapFocus();
            });
        },

        close() {
            if (!this.open) return;
            const self = this;
            const dur  = self._getDuration(self.$root);

            // Resolve edilmemiş confirm varsa false ile kapat
            self._resolveConfirm(false);

            self.$root.dispatchEvent(new CustomEvent('modal:closing', {
                detail: { modal: self },
                bubbles: true,
            }));

            self.$root.setAttribute('closing', '');
            self._backdropEl?.setAttribute('closing', '');

            const finish = () => {
                self.open = false;
                self.$root.removeAttribute('closing');
                self._backdropEl?.removeAttribute('closing');

                const idx = _openModals.indexOf(self);
                if (idx > -1) _openModals.splice(idx, 1);

                if (!_openModals.some(m => m._scrollLock)) _unlockScroll();

                // Hash temizle
                if (location.hash === `#${self.$root.id}`) history.replaceState(null, '', ' ');

                if (_openModals.length) _openModals[_openModals.length - 1]._trapFocus();
                else document.querySelector(`[modal-trigger="#${self.$root.id}"]`)?.focus();

                if (self._focusTrapFn) {
                    document.removeEventListener('keydown', self._focusTrapFn);
                    self._focusTrapFn = null;
                }
            };

            if (dur > 0) setTimeout(finish, dur);
            else finish();
        },


        _trapFocus() {
            const self = this;
            const sel  = 'a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
            const get  = () => [...self.$root.querySelectorAll(sel)];

            get()[0]?.focus();

            if (self._focusTrapFn) document.removeEventListener('keydown', self._focusTrapFn);

            self._focusTrapFn = (e) => {
                if (!self.open || e.key !== 'Tab') return;
                const items = get();
                if (!items.length) { e.preventDefault(); return; }
                const first = items[0], last = items[items.length - 1];
                if (e.shiftKey) { if (document.activeElement === first) { e.preventDefault(); last.focus(); } }
                else            { if (document.activeElement === last)  { e.preventDefault(); first.focus(); } }
            };

            document.addEventListener('keydown', self._focusTrapFn);
        },

        _getDuration(el) {
            if (!el) return 0;
            const s = getComputedStyle(el);
            return Math.max(parseFloat(s.transitionDuration) || 0, parseFloat(s.animationDuration) || 0) * 1000;
        },

        _watch() {
            const self = this;
            self.$watch('open', (val) => {
                self.$root.toggleAttribute('open', val);
                self._backdropEl?.toggleAttribute('open', val);
                self.$root.dispatchEvent(new CustomEvent(val ? 'modal:open' : 'modal:close', {
                    detail: { modal: self },
                    bubbles: true,
                }));
            });
        },

    }));

}

/*
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
KULLANIM — Temel
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

<button modal-trigger="#myModal">Aç</button>

<div x-data="modal" id="myModal">
  <div modal-backdrop></div>
  <div modal-panel>
    <h2>Başlık</h2>
    <button modal-dismiss>Kapat</button>
  </div>
</div>


━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
KULLANIM — Confirm (Promise)
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

<div x-data="modal" id="confirmModal">
  <div modal-backdrop></div>
  <div modal-panel>
    <p>Emin misin?</p>
    <button modal-confirm="yes">Evet</button>
    <button modal-cancel>Hayır</button>
  </div>
</div>

<script>
  const modal = document.querySelector('#confirmModal')._x_dataStack[0]
  const result = await modal.confirm()
  if (result === 'yes') {  }
else { }
</script>


━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
KULLANIM — Opening zinciri
━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

<div x-data="modal" id="modal1" @modal:opening="checkAndOpenOther">
...
</div>

<script>
    document.querySelector('#modal1').addEventListener('modal:opening', (e) => {
        // Bu event handler içinde başka modal açılabilir
        // Her modal kendi state'ini bağımsız yönetir
        const other = document.querySelector('#modal2')._x_dataStack[0]
        other.show() // zincir bozulmaz, her ikisi de opening'ini tamamlar
    })
</script>


━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
ATTRİBUTELER — Trigger:
    modal-trigger="#id"

ATTRİBUTELER — Wrapper:
    id                        zorunlu
scroll-lock="false"       scroll kilidi kapat
backdrop-dismiss="false"  backdrop tıklaması kapatmasın
open                      sayfa açılınca açık

ATTRİBUTELER — İçerik:
    modal-backdrop    backdrop elementi
modal-panel       içerik paneli
modal-dismiss     kapat
modal-confirm=""  değer ile kapat (confirm Promise'e iletilir)
modal-cancel      false ile kapat

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
CSS HOOK'LARI:
    [x-data="modal"][open]       açık
    [x-data="modal"][opening]    açılıyor
    [x-data="modal"][closing]    kapanıyor
    [modal-backdrop][open]       açık backdrop
    [modal-backdrop][opening]    açılıyor
    [modal-backdrop][closing]    kapanıyor

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
EVENTLER (e.detail: { modal }):
modal:opening   açılmadan önce
modal:open      açıldı
modal:closing   kapanmadan önce
modal:close     kapandı

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
JS API:
    modal.show()
modal.hide()
modal.toggle()
await modal.confirm()  → modal-confirm değeri veya false

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
URL HASH:
    Modal açılınca URL #id ile güncellenir
Sayfa #myModal ile açılırsa o modal otomatik açılır
Kapanınca hash temizlenir

━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
KLAVYE:
    Escape   en üstteki modal'ı kapatır
Tab      focus trap
*/